import { Container } from "./styles";
import Lottie from 'react-lottie';
import animationData from '../../lotties/spinner-2.json';

interface LoadSpinnerLoginProps {
    size?: number;
}

export function LoadSpinnerLogin({ size = 45 }: LoadSpinnerLoginProps)  {

    const defaultOptions = {
        loop: true,
        animationData: animationData,
    }

    return (
        <Container>
            <div className='lottie'>
                <div>
                    <Lottie options={defaultOptions} height={size} width={size} />
                </div>
            </div>
        </Container>

    );
}